import { whoWeServe } from '@/lib/aboutPage';

const WhoWeServe = () => {
  return (
    <section
      id="industries"
      className="py-16 md:py-24 px-6 bg-slate-50/50"
      aria-labelledby="industries-heading"
    >
      <div className="max-w-7xl mx-auto">

        {/* Header Section */}
        <header className="text-center mb-12 md:mb-20">
          <div className="flex items-center justify-center gap-2 text-[#4F7AC2] font-bold mb-3">
            <span aria-hidden="true" className="text-xl">»</span>
            <span className="uppercase tracking-[0.2em] text-[10px] sm:text-xs">
              Industries We Support
            </span>
          </div>
          <h2
            id="industries-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#001D4A] leading-tight max-w-3xl mx-auto"
          >
            {whoWeServe.title}
          </h2>
        </header>

        {/* Performance & Layout Optimization:
          We use 'flex' with 'justify-center' so that if the last row 
          has fewer than 3 items, they stay centered. 
        */}
        <div className="flex flex-wrap justify-center gap-6 lg:gap-8">
          {whoWeServe.serve.map((item, index) => (
            <article
              key={item.id || index}
              className="relative bg-white p-8 lg:p-10 shadow-sm border border-slate-100 
                         hover:border-[#4F7AC2] transition-all duration-300 group flex flex-col 
                         rounded-sm min-h-[340px] w-full md:w-[calc(50%-1.5rem)] lg:w-[calc(33.333%-2rem)]
                         focus-within:ring-2 focus-within:ring-[#4F7AC2] outline-none"
            >
              {/* Subtle Index Number */}
              <span
                className="absolute top-6 right-8 text-4xl font-black text-slate-100/50 
                           group-hover:text-[#4F7AC2]/10 transition-colors duration-300 select-none"
                aria-hidden="true"
              >
                0{index + 1}
              </span>

              {/* Icon Container */}
              <div
                className="mb-6 w-14 h-14 flex items-center justify-center rounded-lg 
                           bg-[#4F7AC2]/10 text-[#4F7AC2] 
                           group-hover:bg-[#4F7AC2] group-hover:text-white 
                           group-hover:scale-110
                           transition-all duration-300 ease-in-out shadow-sm group-hover:shadow-md"
                aria-hidden="true"
              >
                {item.icon}
              </div>

              <h3 className="text-xl font-bold text-[#001D4A] mb-4 group-hover:text-[#4F7AC2] transition-colors">
                {item.title}
              </h3>

              <p className="text-gray-600 text-sm sm:text-base leading-relaxed flex-grow">
                {item.description}
              </p>

              {/* Decorative Accent Line */}
              <div
                className="mt-8 h-[2px] w-12 bg-slate-100 group-hover:w-full 
                           group-hover:bg-[#4F7AC2] transition-all duration-500"
                aria-hidden="true"
              />
            </article>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhoWeServe;
